<template>
  <el-dialog
    :title="$t('227')"
    :close-on-click-modal="false"
    append-to-body
    :visible.sync="visible"
    class="select-dep-tree"
  >
    <el-row>
      <el-col :span="11">
        <h3>{{ $t('633') }}</h3>
        <div class="select-dep-tree-item">
          <el-tree
            node-key="department_id"
            ref="tree"
            lazy
            highlight-current
            show-checkbox
            :data="treeList"
            :props="treeProps"
            :load="loadNode"
            :accordion="true"
            :expand-on-click-node="false"
            @check="handleCheckChange"
          >
            <!-- @current-change="handleCurrentChange" -->
          </el-tree>
        </div>
      </el-col>
      <el-col :span="2"></el-col>
      <el-col :span="11" style="float: right">
        <h3>{{ $t('179') }}</h3>
        <div class="select-dep-tree-item">
          <el-tag v-for="(tag, index) in selectArr" :key="index" closable :type="'success'" @close="handleClose(tag)">
            {{ tag.department_name }}
          </el-tag>
        </div>
      </el-col>
    </el-row>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" plain @click="sure">
        {{ $t('131') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { depListFn, orgInfoFn } from 'api/org/dep'
// import { listUrl } from 'api/org/per'

export default {
  data() {
    return {
      visible: false,
      treeList: [],
      treeProps: {
        label: 'department_name',
        isLeaf: 'is_sub_department'
      },
      selectArr: []
    }
  },
  methods: {
    init() {
      this.visible = true
      this.getOrgInfo()
      this.selectArr = []
    },
    async getOrgInfo() {
      this.treeList = []
      const res = await orgInfoFn()
      if (res && res.code === 1) {
        this.treeList.push({
          is_sub_department: false,
          department_name: res.data.department_name,
          department_id: Number(res.data.id),
          supervisor_id: res.data.supervisor_id,
          supervisor_name: res.data.supervisor_name
        })
      }
    },
    loadNode(node, resolve) {
      if (node.data.department_id) {
        depListFn({ department_id: node.data.department_id }).then(res => {
          this.tableData = res.data
          resolve(
            res.data.map(v => ({
              department_name: v.department_name,
              department_id: Number(v.department_id),
              is_sub_department: !v.is_sub_department,
              supervisor_id: v.supervisor_id,
              supervisor_name: v.supervisor_name
            }))
          )
        })
      }
    },
    handleCheckChange(val, { checkedNodes }) {
      this.selectArr = this.$refs.tree.getCheckedNodes()
    },
    handleCurrentChange(val, node) {},
    handleClose(item) {
      this.selectArr.splice(this.selectArr.indexOf(item), 1)
      this.$refs.tree.setChecked(item, false, true)
    },
    sure() {}
  }
}
</script>

<style lang="less" scoped>
.select-dep-tree {
  .el-row {
    height: 500px;
    .select-dep-tree-item {
      height: 450px;
      padding: 10px;
      box-sizing: border-box;
      overflow: auto;
      background-color: #f5f5f5;
    }
  }
  /deep/ .el-tree {
    background-color: #f5f5f5;
  }
  /deep/ .el-tree-node__content {
    height: 36px;
    line-height: 36px;
  }
  /deep/ .el-tree-node__content:hover {
    background-color: #fff;
  }
  /deep/ .el-checkbox__inner {
    width: 16px;
    height: 16px;
  }
  /deep/ .el-tree-node__label {
    font-size: 16px;
  }
  .el-tag {
    margin: 0 0px 10px 0;
    width: 100%;
    box-sizing: border-box;
    font-size: 14px;
    height: auto;
    line-height: 30px;
    position: relative;
    padding: 0 10px;
    /deep/ .el-icon-close {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 10px;
      margin: auto;
      font-size: 20px;
      height: 24px;
      width: 24px;
      line-height: 24px;
    }
  }
}
</style>
